import { COMMON } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        walkthroughTitle: 'Walkthrough',
        walkthroughStep: `
            Welcome to the ${ COMMON.appName } walkthrough. This process will familiarize you with the tools are your disposal and guide you through the process of making a board.
            <br><br>
            Click the next arrow to continue.
        `,

        toolbarTitle: 'Toolbar',
        toolbarStep: 'This is the main toolbar. Clicking it will display base level actions you can use to manipulate the board.',
        toolbarStepHelp: 'First, if you ever need help again, you can simply click the "Help" button to run this walkthrough again.',
        toolbarStepZoom: 'You can control how much of the board you see by using the zoom options, or by scrolling the mousewheel.',
        toolbarStepAddNode: 'The "Add a Node" button will allow you to add a new, unconnected node to the board.',


        createNodeTitle: 'Creating a New Node',
        createNodeStep: 'Clicking the "Add a Node" button will open a modal allowing you to create a basic node.',
        createNodeStepNodeType: `
            The "Node Type" field allows you to choose the type of node you wish to create. The types of node you can create are ${ COMMON.en.person }, ${ COMMON.en.place }, ${ COMMON.en.event }, and ${ COMMON.en.organization }.<br><br>
            Nodes will act as though they are pins in a cork board that you can tie together.
        `,
        createNodeStepNodeName: `
            The "Node Name" field applies a name to the ${ COMMON.en.person }, ${ COMMON.en.place }, ${ COMMON.en.event }, or ${ COMMON.en.organization }
            you are creating.<br><br>
            This value of this field should be a proper noun. For example, if you are creating a ${ COMMON.en.person } node, you should enter that person's name here.
        `,
        createNodeStepNodeAdd: `
            Clicking the, "Add" button will commit your node to the board. You can only add a node once both the type and name fields have been populated.
        `,

        editingNodesTitle: 'Changing Nodes',
        editingNodesStep: `
            Once you've added a node, its type becomes immutable. However, you can begin to manipulate it in other ways.
            <br><br>
            For starters, if you don't like where a node is, you can simply drag and drop to where you think it should be placed.
        `,
        editingNodesStepDetails: `
            You can also open the option menu for additional actions, such as: <br>
            - Managing its connection to other nodes<br>
            - Adding relevant details to the node<br>
            - Adding substantiating links from archive websites (e.g. evidence)
        `,

        namingBoardTitle: 'Naming the Board',
        namingBoardStep: `
            For organizational purposes, you can also name the board, preferably something relevant to the case you're attempting to prove.<br><br>
            The board name is also used to generate an image for the NFT should you choose to mint it.
        `,
        
        lastStepsTitle: 'Finishing Your Board',
        lastStepsStepSave: `
            If you need to take a break, you can save your board locally from clicking the, "Save Board" option
            in the main menu.
            <br><br> 
            You can also resume working on that board by clicking the, "Open Locally Saved Board" option to load the file.
        `,
        lastStepsStepMint: `
            Once you've got your board to a point you feel is satisfactory, you can choose to mint your board as an NFT, by clicking this button (assuming you've connected your wallet).
        `,
        lastStepsStepOffers: `
            Should you choose to mint your board, it will then appear in your collection. It will also appear in the marketplace, where other users can send you offers to sell, which you can either approve or reject.<br><br>
            Both your collection and the marketplace are accessible through the main menu.
        `,

        doneTitle: 'Conclusion',
        doneStep: `
            That's about it. Be sure to visit the About page if you need clarification on some of the finer details.
        `

    }
}

export default TRANSLATIONS